export const enum ActorType {
    Friendly = -1,
    Enemy = 1,
}